import DrawRect from '../../interaction/drawRect';
import Select from '../../interaction/select/index';
import NextTick from '../../utils/nextTick';

function init(): void {
    DrawRect.onSelected((rect: Rect): void => {
        NextTick(() => {
            Select.byRect(rect);
        });
    });
}

export default {
    init
};
